function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Iterator from '../../../../java/util/Iterator';
import NoSuchElementException from '../../../../java/util/NoSuchElementException';
import GeometryCollection from './GeometryCollection';
import UnsupportedOperationException from '../../../../java/lang/UnsupportedOperationException';
var GeometryCollectionIterator = /*#__PURE__*/function () {
  function GeometryCollectionIterator() {
    _classCallCheck(this, GeometryCollectionIterator);
    GeometryCollectionIterator.constructor_.apply(this, arguments);
  }
  return _createClass(GeometryCollectionIterator, [{
    key: "next",
    value: function next() {
      if (this._atStart) {
        this._atStart = false;
        if (GeometryCollectionIterator.isAtomic(this._parent)) this._index++;
        return this._parent;
      }
      if (this._subcollectionIterator !== null) {
        if (this._subcollectionIterator.hasNext()) {
          return this._subcollectionIterator.next();
        } else {
          this._subcollectionIterator = null;
        }
      }
      if (this._index >= this._max) {
        throw new NoSuchElementException();
      }
      var obj = this._parent.getGeometryN(this._index++);
      if (obj instanceof GeometryCollection) {
        this._subcollectionIterator = new GeometryCollectionIterator(obj);
        return this._subcollectionIterator.next();
      }
      return obj;
    }
  }, {
    key: "remove",
    value: function remove() {
      throw new UnsupportedOperationException(this.getClass().getName());
    }
  }, {
    key: "hasNext",
    value: function hasNext() {
      if (this._atStart) {
        return true;
      }
      if (this._subcollectionIterator !== null) {
        if (this._subcollectionIterator.hasNext()) {
          return true;
        }
        this._subcollectionIterator = null;
      }
      if (this._index >= this._max) {
        return false;
      }
      return true;
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return GeometryCollectionIterator;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [Iterator];
    }
  }], [{
    key: "isAtomic",
    value: function isAtomic(geom) {
      return !(geom instanceof GeometryCollection);
    }
  }]);
}();
export { GeometryCollectionIterator as default };
GeometryCollectionIterator.constructor_ = function () {
  this._parent = null;
  this._atStart = null;
  this._max = null;
  this._index = null;
  this._subcollectionIterator = null;
  var parent = arguments[0];
  this._parent = parent;
  this._atStart = true;
  this._index = 0;
  this._max = parent.getNumGeometries();
};